import styled, { css } from "styled-components";

export var Container = styled.div`
    position: relative;
    display: inline-block;
`;

export var NavigationContainer = styled.div`
    display: flex;
    align-items: center;
    height: 36px;
    padding: 0 4px;
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    transition: all 0.2s ease;
    gap: 2px;

    &:hover {
        border-color: #1890ff;
        box-shadow: 0 2px 6px rgba(24, 144, 255, 0.1);
    }

    ${function(props) {
        if (props.disabled) {
            return css`
                background: #f5f5f5;
                cursor: not-allowed;

                &:hover {
                    border-color: #e8e8e8;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
                }
            `;
        }
        return '';
    }}
`;

export var NavArrow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    color: #8c8c8c;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.15s ease;
    user-select: none;

    &:hover {
        background: #f0f5ff;
        color: #1890ff;
    }

    &:active {
        background: #e6f7ff;
        transform: scale(0.95);
    }

    .anticon {
        font-size: 12px;
        font-weight: 600;
    }

    ${function(props) {
        if (props.disabled) {
            return css`
                color: #d9d9d9;
                cursor: not-allowed;

                &:hover {
                    background: transparent;
                    color: #d9d9d9;
                }

                &:active {
                    transform: none;
                }
            `;
        }
        return '';
    }}
`;

export var MonthDisplay = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 150px;
    height: 28px;
    padding: 0 12px;
    font-size: 14px;
    font-weight: 500;
    color: #262626;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.15s ease;
    user-select: none;

    &:hover {
        background: #fafafa;
        color: #1890ff;
    }

    ${function(props) {
        if (props.isOpen) {
            return css`
                background: #e6f7ff;
                color: #1890ff;
            `;
        }
        return '';
    }}

    ${function(props) {
        if (props.disabled) {
            return css`
                color: rgba(0, 0, 0, 0.25);
                cursor: not-allowed;

                &:hover {
                    background: transparent;
                    color: rgba(0, 0, 0, 0.25);
                }
            `;
        }
        return '';
    }}
`;

export var TodayButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    padding: 0 10px;
    color: #1890ff;
    cursor: pointer;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 500;
    margin-left: 2px;
    border-left: 1px solid #f0f0f0;
    padding-left: 10px;
    transition: all 0.15s ease;
    white-space: nowrap;

    &:hover {
        background: #e6f7ff;
        color: #40a9ff;
    }

    &:active {
        background: #bae7ff;
    }

    ${function(props) {
        if (props.isActive) {
            return css`
                background: #1890ff;
                color: #fff;

                &:hover {
                    background: #40a9ff;
                    color: #fff;
                }
            `;
        }
        return '';
    }}

    ${function(props) {
        if (props.disabled) {
            return css`
                color: #d9d9d9;
                cursor: not-allowed;

                &:hover {
                    background: transparent;
                    color: #d9d9d9;
                }
            `;
        }
        return '';
    }}
`;

export var Dropdown = styled.div`
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    z-index: 1050;
    min-width: 300px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08),
                0 3px 6px -4px rgba(0, 0, 0, 0.12),
                0 9px 28px 8px rgba(0, 0, 0, 0.05);
    overflow: hidden;

    ${function(props) {
        if (props.align === 'right') {
            return css`
                left: auto;
                right: 0;
            `;
        }
        return '';
    }}
`;

export var Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 14px 12px;
    gap: 4px;
`;

export var NavButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    padding: 0;
    background: transparent;
    border: none;
    border-radius: 8px;
    color: #8c8c8c;
    cursor: pointer;
    transition: all 0.15s ease;

    &:hover {
        background: #f0f5ff;
        color: #1890ff;
    }

    &:active {
        background: #e6f7ff;
    }

    &:disabled {
        color: #d9d9d9;
        cursor: not-allowed;
        background: transparent;
    }
`;

export var YearDisplay = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;

export var YearText = styled.span`
    font-size: 16px;
    font-weight: 700;
    color: #262626;
    min-width: 56px;
    text-align: center;
`;

export var MonthGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 6px;
    padding: 4px 14px 14px;
`;

export var MonthCell = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 36px;
    padding: 0;
    background: transparent;
    border: 1.5px solid transparent;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 500;
    color: #595959;
    cursor: pointer;
    transition: all 0.15s ease;
    text-transform: capitalize;

    &:hover {
        background: #f0f5ff;
        color: #1890ff;
    }

    ${function(props) {
        if (props.isSelected) {
            return css`
                background: #1890ff;
                border-color: #1890ff;
                color: #fff;
                font-weight: 600;

                &:hover {
                    background: #40a9ff;
                    border-color: #40a9ff;
                    color: #fff;
                }
            `;
        }
        return '';
    }}

    ${function(props) {
        if (props.isCurrent && !props.isSelected) {
            return css`
                border-color: #1890ff;
                color: #1890ff;
                font-weight: 600;
            `;
        }
        return '';
    }}

    ${function(props) {
        if (props.disabled) {
            return css`
                color: #d9d9d9;
                cursor: not-allowed;
                background: transparent;

                &:hover {
                    background: transparent;
                    border-color: transparent;
                    color: #d9d9d9;
                }
            `;
        }
        return '';
    }}
`;

export var Footer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 10px 14px;
    border-top: 1px solid #f0f0f0;
`;

export var FooterButton = styled.button`
    flex: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    padding: 0 10px;
    background: transparent;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 500;
    color: #595959;
    cursor: pointer;
    transition: all 0.15s ease;
    white-space: nowrap;

    &:hover {
        border-color: #1890ff;
        color: #1890ff;
        background: #f0f5ff;
    }

    &:active {
        background: #e6f7ff;
    }
`;

export var Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1040;
`;
